import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TITLES = {
  '/':                  'Dashboard',
  '/employees':         'Employees',
  '/employees/create':  'Add New Employee',
  '/alerts':            'Alerts & Expiry Tracking',
  '/audit':             'Audit Readiness',
};

export default function Header() {
  const location = useLocation();
  const navigate  = useNavigate();

  // Match title – handle dynamic routes like /employees/5
  let title = 'Compliance Tracker';
  for (const [path, label] of Object.entries(TITLES)) {
    if (location.pathname === path) { title = label; break; }
  }
  if (/^\/employees\/\d+$/.test(location.pathname))            title = 'Employee Profile';
  if (/^\/employees\/\d+\/documents$/.test(location.pathname)) title = 'Employee Documents';

  const [today, setToday] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setToday(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  const canGoBack = location.pathname !== '/';

  return (
    <header className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between shrink-0">
      <div className="flex items-center gap-3">
        {canGoBack && (
          <button
            onClick={() => navigate(-1)}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition-colors"
            title="Go back"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <h1 className="text-lg font-semibold text-slate-800">{title}</h1>
      </div>

      <div className="flex items-center gap-3">
        <span className="text-xs text-slate-400">
          {today.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
        </span>
      </div>
    </header>
  );
}
